import Event from '../../core/Event';

export default class OrderPlaceRequestSent extends Event {
    public static type = 'OrderPlaceRequestSent';

    constructor() {
        super(OrderPlaceRequestSent.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderPlaceRequestSent.ts